import { render } from "./PublicFooter.vue?vue&type=template&id=5fa7b443&scoped=true"
const script = {}

import "./PublicFooter.vue?vue&type=style&index=0&id=5fa7b443&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa7b443"]])

export default __exports__